<template>
<div class="cb-body__wrap">
    <div class="cb-body__content">
        <div class="cb-section">
            <div class="cb-note cb-note--left cb-note--align cb-note--fw" v-if="agreements">
                <div class="cb-note__content">
                    <template v-for="(value, key) in agreements">
                        <div class= "cb-note__p" v-cb-html="value" v-bind:key="key"></div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {
  mapGetters
} from "vuex"
export default {
   computed: {
    ...mapGetters([
      "pm_list",
    ]),
    pm(){
      return this.pm_list.filter(pm => pm.configuration && pm.configuration.scheme == 'BACS')[0];
    },
    agreements() {
        return this.pm && this.pm.configuration && this.pm.configuration.agreement_list;
    }
   }
}
</script>



// WEBPACK FOOTER //
// GocardlessBacsGuarantee.vue?176cad2d